export default "__VITE_ASSET__VkFPBcPQ__"